import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'
import { getServerTimestamp } from '@/utils/serverTime'

function randomBytes(length) {
  const arr = new Uint8Array(length)
  window.crypto.getRandomValues(arr)
  return arr
}

function bytesToWordArray(bytes) {
  const words = []
  for (let i = 0; i < bytes.length; i += 4) {
    words.push(((bytes[i] || 0) << 24) | ((bytes[i + 1] || 0) << 16) | ((bytes[i + 2] || 0) << 8) | (bytes[i + 3] || 0))
  }
  return CryptoJS.lib.WordArray.create(words, bytes.length)
}

function bytesToHex(bytes) {
  return Array.from(bytes)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
}

/**
 * 生成随机重置密码（至少8位，包含数字+字母+至少1个特殊字符）
 * @param {number} len - 密码长度，默认8
 * @returns {string}
 */
export function generateResetPassword(len = 8) {
  const digits = '0123456789'
  const letters = 'abcdefghijklmnopqrstuvwxyz'
  const specials = '!@#$%&*'
  const all = digits + letters + letters.toUpperCase() + specials

  // 保证至少1个数字、1个小写字母、1个大写字母、1个特殊字符
  const pick = str => str[Math.floor(Math.random() * str.length)]
  const required = [pick(digits), pick(letters), pick(letters.toUpperCase()), pick(specials)]

  for (let i = required.length; i < len; i++) {
    required.push(pick(all))
  }

  // 打乱顺序
  for (let i = required.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[required[i], required[j]] = [required[j], required[i]]
  }

  return required.join('')
}

export function encryptLoginPassword(password, publicKey) {
  const aesKeyBytes = randomBytes(16)
  const ivBytes = randomBytes(16)
  const timestamp = getServerTimestamp()
  const salt = bytesToHex(randomBytes(8))

  const data = `${password}|${timestamp}|${salt}`

  const aesKeyWA = bytesToWordArray(aesKeyBytes)
  const ivWA = bytesToWordArray(ivBytes)

  const encryptedPassword = CryptoJS.AES.encrypt(data, aesKeyWA, {
    iv: ivWA,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString()

  const keyStr =
    typeof publicKey === 'string' ? publicKey : publicKey.publicKey || publicKey.key || publicKey.data || ''
  const pemKey = keyStr.includes('-----') ? keyStr : `-----BEGIN PUBLIC KEY-----\n${keyStr}\n-----END PUBLIC KEY-----`

  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(pemKey)
  const aesKeyBase64 = btoa(String.fromCharCode(...aesKeyBytes))
  const encryptedKey = encryptor.encrypt(aesKeyBase64)

  return {
    encryptedPassword,
    encryptedKey,
    iv: btoa(String.fromCharCode(...ivBytes)),
    timestamp,
    salt
  }
}
